import * as React from 'react';
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Button, Typography } from '@material-ui/core';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import InboxIcon from '@material-ui/icons/Inbox';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import { makeStyles } from '@material-ui/core/styles';
import { USER_ROLES } from 'utils/constants';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
        },
    },
    filterTitle: {
        fontSize: 'clamp(1.25rem, 2vw, 1.5rem)',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
    listItemText: {
        '& .MuiListItemText-primary': {
            fontSize: 'clamp(0.875rem, 1.5vw, 1rem)',
            wordBreak: 'break-word',
        },
    },
    addButton: {
        marginTop: 20,
        marginLeft: 10,
        borderRadius: 5,
        padding: '10px 20px',
        [theme.breakpoints.down('xs')]: {
            marginLeft: 0,
            marginTop: 16,
            padding: '8px 16px',
            width: '100%',
        },
    },
}));

const CalendarSidebar = ({ changeDate, eventList, date, handleAddEvent }) => {
    const classes = useStyles();
    const role = localStorage.getItem('role');
    const ChangeColorFunction = () => {
        var ColorCode = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
        return ColorCode
    }

    return (
        <div className={classes.root}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                    autoOk
                    variant="static"
                    openTo="date"
                    value={date}
                    onChange={(date) => changeDate(date)}
                />
            </MuiPickersUtilsProvider>
            {eventList && eventList.length > 0 ? (
                <>
                    <Typography variant="h4" className={classes.filterTitle}>Filter Events</Typography>
                    <List dense>
                        {eventList.map(event => (
                            <ListItem key={event.uuid}>
                                <ListItemIcon style={{ color: `${ChangeColorFunction()}`, minWidth: 36 }}>
                                    <InboxIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={event.name} className={classes.listItemText} />
                            </ListItem>
                        ))}
                    </List>
                </>
            ) : null}
            { (role === USER_ROLES.CUSTOMER_ADMIN || role === USER_ROLES.PROJECT_ADMIN) && (
                <Button variant="outlined" onClick={handleAddEvent} color="primary" className={classes.addButton}>
                    <AddBoxOutlinedIcon style={{ marginRight: 10 }} />Add Event
                </Button>
            )}
        </div>
    );
}

export default CalendarSidebar;